// FormItemsComponent.js
import React from "react";
import FormItemComponent from "./FormItemComponent";

const FormItemsComponent = ({
  obj,
  parentName = [],
  fieldValue = {},
  fieldOptions = {},
  form,
  formClass
}) => {
  return (
    <>
      {Object.keys(obj).map((key) => {
        const value = obj[key];
        const currentName = [...parentName, key];
        return (
          <FormItemComponent
            keyProp={key}
            name={currentName}
            value={value}
            fieldOptions={fieldOptions} // Pass fieldOptions from parent
            fieldValue={fieldValue} // Pass fieldValue from parent
            form={form}
            formClass={formClass}
          />
        );
      })}
    </>
  );
};

export default FormItemsComponent;
